/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamFunkceSchvalovaciSablonyEpk extends GContentBase<SeznamFunkceSchvalovaciSablonyEpkObj> {
        private seznamObj: SeznamFunkceSchvalovaciSablonyEpkObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamFunkceSchvalovaciSablonyEpkObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamFunkceSchvalovaciSablonyEpkNew",
                contentCaption: "jres:33000900", //RC 33000900 : Přiřazené funkce schvalovacím šablonámi EPK
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_fun_txt} - {ixs_ssa_txt} - {ixs_sro_txt} - {dat_od}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            let columnOrder = "";
            if (this.ixs_ssa)
                columnOrder += "ixs_fun_txt,ixs_sro_txt,"
            else if (this.ixs_fun)
                columnOrder += "ixs_ssa_txt,ixs_sro_txt,"
            else if (this.ixs_sro)
                columnOrder += "ixs_fun_txt,ixs_ssa_txt,"
            else {
                columnOrder += "ixs_fun_txt,ixs_ssa_txt,ixs_sro_txt"
            }
            columnOrder += "dat_od,dat_do,dat_zmena,zmenu_prov_txt";
            return columnOrder;
        }
    }

    export class SeznamFunkceSchvalovaciSablonyEpkObj extends GAdmSeznamBase {
        ixs_ssa: string;
        ixs_fun: string;
        ixs_sro: string;

        private openType(): number {
            if (this.ixs_ssa)
                return 10
            else if (this.ixs_sro)
                return 20
            else
                return 30

        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailFunkceSchvalovaciSablonyEpk", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openType: this.openType(),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailFunkceSchvalovaciSablonyEpk",
                newRecord: isNew,
                ixs_sro: isNew == true ? (this.ixs_sro ? this.ixs_sro : null) : data.ixs_sro,
                ixs_ssa: isNew == true ? (this.ixs_ssa ? this.ixs_ssa : null) : data.ixs_ssa,
                ixs_fun: isNew == true ? (this.ixs_fun ? this.ixs_fun : null) : data.ixs_fun,
                dat_od: isNew == true ? null : data.dat_od
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"/*, "actOpenDialogVyberovaSkupina*"*/]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"/*, "actOpenDialogVyberovaSkupina*"*/])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131048").addField("gselectbox", Gordic.Prefabs.Select.wflssro(), { //RC 33000888 : Skupina funkcí
                name: "ixs_sro",
                model: "model.ixs_sro=value.ixs_sro",
                dropdown: true,
                disabled: (this.ixs_sro) ? true : false
            })
            .addRow("jres:32131057").addField("gselectbox", Gordic.Prefabs.Select.wflsssa(), {
                name: "ixs_ssa",
                model: "model.ixs_ssa=value.ixs_ssa",
                dropdown: true,
                disabled: (this.ixs_ssa) ? true : false
            })
            .addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                disabled: (this.ixs_fun) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_sro)
                hardFilter["ixs_sro"] = this.ixs_sro;
            if (this.ixs_ssa)
                hardFilter["ixs_ssa"] = this.ixs_ssa;
            if (this.ixs_fun)
                hardFilter["ixs_fun"] = this.ixs_fun;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_sro)
                data["ixs_sro"] = this.ixs_sro;
            if (this.ixs_ssa)
                data["ixs_ssa"] = this.ixs_ssa;
            if (this.ixs_fun)
                data["ixs_fun"] = this.ixs_fun;
        }

        applydata(filterData: any) {
            this.cnt.isl.FunkceSchvalovaciSablonyEpk.list({ filters: filterData }).getView().then((data) => {
                this.setPlatnostColumn(data)
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}#${data.ixs_ssa}#${data.ixs_sro}#${data.dat_od}#`,
                nazev: `${data.ixs_sfu_txt} - ${data.ixs_ssa_txt} - ${data.ixs_fun_txt} - ${Gordic.Templates.Formatters.date(data.dat_od)}`
            }
        }
    }
}